import { render, staticRenderFns } from "./jiaru2.vue?vue&type=template&id=1ec28768&scoped=true"
import script from "./jiaru2.vue?vue&type=script&lang=js"
export * from "./jiaru2.vue?vue&type=script&lang=js"
import style0 from "./jiaru2.vue?vue&type=style&index=0&id=1ec28768&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec28768",
  null
  
)

export default component.exports